import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWebsite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWebsite"><Path d="M10.5 10.5L7.5 13.5L10.5 16.5" stroke="currentColor"/><Path d="M13.5 10.5L16.5 13.5L13.5 16.5" stroke="currentColor"/><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M3.5 6.5H20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconWebsite;
